/**
 * @fileoverview Closure Type definitions and utils for common component props
 * @author Derek Seo (dseo@yext.com)
 */

goog.declareModuleId('yext.ui.lib.props');

/**
 * @typedef {string}
 */
export let LabelNotLabelledBy;

/**
 * @typedef {{
 *   labelledBy: string,
 * }}
 */
export let LabelledBy;

/**
 * Mandatory prop which should be forwarded
 * either to aria-label or aria-labelledby
 * See https://w3c.github.io/aria/#aria-label
 *
 * @typedef {(!LabelNotLabelledBy | !LabelledBy)}
 */
export let Label;

/**
 * Given a Label prop, returns an object containing the aria label or labelledby
 * attributes to be spread into the HTML element.
 *
 * @param {!Label} label
 * @returns {(
 *   {'aria-label': string} |
 *   {'aria-labelledby': string}
 * )}
 */
export function getLabelAttrs(label) {
  return typeof label === 'string'
    ? {'aria-label': label}
    : {'aria-labelledby': label.labelledBy};
}
